var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.29 4.125h-2.667v2a1.467 1.467 0 1 1-2.933 0v-2H8.923v2a1.467 1.467 0 0 1-2.933 0v-2H3.323a1.187 1.187 0 0 0-1.2 1.207v14.92a1.187 1.187 0 0 0 1.167 1.206h19a1.188 1.188 0 0 0 1.166-1.206V5.332a1.186 1.186 0 0 0-1.166-1.207zM7.457 17.458H6.123v-1.333h1.334v1.333zm0-3.333H6.123v-1.333h1.334v1.333zm0-3.333H6.123V9.458h1.334v1.334zm4 6.666h-1.334v-1.333h1.334v1.333zm0-3.333h-1.334v-1.333h1.334v1.333zm0-3.333h-1.334V9.458h1.334v1.334zm4 6.666h-1.334v-1.333h1.334v1.333zm0-3.333h-1.334v-1.333h1.334v1.333zm0-3.333h-1.334V9.458h1.334v1.334zm4 6.666h-1.334v-1.333h1.334v1.333zm0-3.333h-1.334v-1.333h1.334v1.333zm0-3.333h-1.334V9.458h1.334v1.334z",
    fill: "#8199B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.457 6.791a.667.667 0 0 0 .666-.666v-4a.667.667 0 0 0-1.333 0v4a.667.667 0 0 0 .667.666zM18.124 6.791a.667.667 0 0 0 .666-.666v-4a.667.667 0 0 0-1.333 0v4a.667.667 0 0 0 .667.666z",
    fill: "#8199B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputCalendarIcon);
export default __webpack_public_path__ + "static/media/Input-Calendar-Icon.9741de166b67c2ee9eb80146a913f6db.svg";
export { ForwardRef as ReactComponent };